// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2x51C","dragIcon":"Choice_dragIcon__2h7h9","left":"Choice_left__2bmCe","input":"Choice_input__2ILmk"};